<template>
  <footer-dark is-dark></footer-dark>
</template>

<script>
import Footer from './Footer.vue'
export default {
  components: { FooterDark: Footer },
}
</script>
